export abstract class NavigationService {
  selectedOption = 'dashboard';

  constructor() {
  }

  goToDashboar() {
  }

  selectOption(option) {
    this.selectedOption = option;
    switch (this.selectedOption) {
      case 'dashboard':
        this.navigateToDashboard();
        break;
      case 'reglasNegocio':
        break;
      case 'conciliacion':
        break;
      case 'pagos':
        //this.navigateToPayments();
        break;
      case 'banners':
        this.navigateToBanners();
        break;
      case 'business-rules':
        this.navigateToBusinessRules();
        break;
    }
  }

  selectConciliacionOption(conciliacionOption) {
    this.selectedOption = 'conciliacion';
  }

  abstract navigateToDashboard();

  abstract navigateToPayments();

  abstract navigateToBusinessRules();

  abstract navigateToBanners();
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/navigation.service.ts